import { render, staticRenderFns } from "./ShippedButton.vue?vue&type=template&id=72ba3758"
import script from "./ShippedButton.vue?vue&type=script&lang=js"
export * from "./ShippedButton.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports